import { render, staticRenderFns } from "./LvSortQuesOptionList.vue?vue&type=template&id=58dce89a"
import script from "./LvSortQuesOptionList.vue?vue&type=script&lang=js"
export * from "./LvSortQuesOptionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports